<template>
  <div class="form-wapper-container">
    <h1 class="title">{{ $t("contact.form.h1") }}</h1>
    <p class="sub-title" v-if="$i18n.locale !== 'ru-RU'">LIAN XI WO MEN</p>

    <div class="form">
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-row :gutter="48">
          <a-col :span="12">
            <a-form-model-item :label="$t('contact.form.label.name')" prop="username">
              <a-input v-model="form.username" size="large" :placeholder="$t('contact.form.label.name.placeholder')"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('contact.form.label.type')" prop="category">
              <a-select v-model="form.category" size="large" :placeholder="$t('contact.form.label.type.placeholder')">
                <a-select-option :value="$t('contact.form.label.type.option.01')"> {{ $t('contact.form.label.type.option.01') }} </a-select-option>
                <a-select-option :value="$t('contact.form.label.type.option.02')"> {{ $t('contact.form.label.type.option.02') }} </a-select-option>
                <a-select-option :value="$t('contact.form.label.type.option.03')"> {{ $t('contact.form.label.type.option.03') }} </a-select-option>
                <a-select-option :value="$t('contact.form.label.type.option.04')"> {{ $t('contact.form.label.type.option.04') }} </a-select-option>
                <a-select-option :value="$t('contact.form.label.type.option.other')"> {{ $t('contact.form.label.type.option.other') }} </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label="$t('contact.form.label.email')" prop="email">
              <a-input v-model="form.email" size="large" :placeholder="$t('contact.form.label.email.placeholder')"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('contact.form.label.phone')" prop="contact_information">
              <a-input v-model="form.contact_information" size="large" :placeholder="$t('contact.form.label.phone.placeholder')"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="$t('contact.form.label.content')" prop="description">
              <a-textarea
                v-model="form.description"
                size="large"
                :placeholder="$t('contact.form.label.content.placeholder')"
                :rows="16"
                style="resize: none"
              ></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-button type="primary" size="large" :loading="loading" @click="submit">{{ $t("content.form.submit") }}</a-button>
    </div>

    <!-- 验证码模态框 -->
    <a-modal :visible="codeVisible" @ok="codeModalOk" @cancel="codeModalCancel" centered>
      <p>
        看不清验证码？<a :disabled="codeDisabled" @click="getCode">{{ codeText }}</a>
      </p>
      <a-input v-model="captcha" placeholder="请输入验证码" size="large">
        <img slot="addonAfter" style="width: 144px; height: 38px" :src="codeUrl" alt="" />
      </a-input>
    </a-modal>
  </div>
</template>

<script>
import { reqAuthCode, reqCreateMessage } from "@/api/index";

export default {
  data() {
    return {
      loading: false,
      form: {
        username:undefined,
        category:undefined,
        email:undefined,
        contact_information:undefined,
        description:undefined
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      codeVisible: false,
      codeDisabled: false,
      codeUrl: "",
      codeText: "换一张",
      captcha: "", //验证码
    };
  },
  computed: {
    rules() {
      return {
        username: [{ required: true, message: this.$t("contact.form.label.name.placeholder"), trigger: "blur" }],
        // category: [{ required: true, message: this.$t("contact.form.label.type.placeholder"), trigger: "blur" }],
        // email: [{ required: true, message: this.$t("contact.form.label.email.placeholder"), trigger: "blur" }],
        contact_information: [{ required: true, message: this.$t("contact.form.label.phone.placeholder"), trigger: "blur" }],
        // description: [{ required: true, message: this.$t("contact.form.label.content.placeholder"), trigger: "blur" }],
      };
    },
  },
  methods: {
    // 提交留言
    submit() {
      this.loading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await reqAuthCode();
          if (res.data.code === 1) {
            this.codeUrl = res.data.data;
            this.codeVisible = true;
          } else {
            this.$message.error(res.data.msg);
          }
          this.loading = false;
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    // 验证码框子关闭
    codeModalCancel() {
      this.captcha = "";
      this.codeVisible = false;
    },
    // 用户提交了验证码
    async codeModalOk() {
      let submitData = { ...this.form, captcha: this.captcha };

      const res = await reqCreateMessage({ ...submitData });

      if (res.data.code === 1) {
        this.captcha = "";
        this.$refs.form.resetFields();
        this.$message.success(res.data.msg);
        this.codeVisible = false;
      } else {
        this.$message.error(res.data.msg);
      }
    },
    // 获取验证码
    async getCode() {
      const res = await reqAuthCode();
      if (res.data.code === 1) {
        this.codeUrl = res.data.data;
      } else {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form-wapper-container {
  padding: 24px 0 48px 0;
  //   background-color: #ccc;
  .title {
    margin: 0;
    font-weight: bold;
    color: #ff5d1b;
    text-align: center;
  }
  .sub-title {
    text-align: center;
  }
  .form {
    margin: 0 auto;
    width: 50%;
  }
}
</style>
